import { API, Auth, Analytics } from "aws-amplify";
import {
  SETUP_TOTP,
  SETUP_SMS,
  ENTER_VERIFICATION_MFA_CODE,
  SETUP_MFA_INFO,
  AUTH_USER,
  FETCH_MY_CONTACTS,
  PUSH_NOTIFICATION,
  REINVITE_USER,
  CHANGE_USER_ROLE
} from "./types";
import { ANALYTICS_EVENT } from "../../common/ApmlifyRecordEvents";

import { generateUserPicture } from "../../common/utils";

import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("app_configuration").CONFIGURATION[environment];

const API_REQUEST_FIXED_PARAMS = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

export const setupTOTP = (user, toggle_value) => {
  return function(dispatch) {
    console.log("from profileScreenActions setupTOTP toggle_value: ", toggle_value);

    if (typeof toggle_value === "undefined" || toggle_value === null) return;

    if (toggle_value === "NOMFA" || toggle_value === "SMS") {
      dispatch({ type: SETUP_MFA_INFO });
      if (toggle_value === "SMS" && user.attributes.phone_number_verified === false) {
        // dispatch({ type: SETUP_MFA_SMS_ERROR, payload: "In order to use SMS MFA verify your phone number first." });
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: { message: "In order to use SMS MFA verify your phone number first.", type: "error" }
        });
      } else {
        Auth.setPreferredMFA(user, toggle_value)
          .then(data => {
            console.log("from profileAcreenActions Auth.setupTOTP : ", data);

            const message =
              toggle_value === "NOMFA" ? "Successfully turned off MFA." : "Successfully set SMS for your MFA method.";
            // dispatch({ type: SETUP_MFA_INFO, payload: { message: message, type: "info" } });
            dispatch({
              type: PUSH_NOTIFICATION,
              payload: { message: message, type: "success" }
            });
            // ...
          })
          .then(() => {
            dispatch({ type: SETUP_SMS });
            if (toggle_value === "SMS") Analytics.record(ANALYTICS_EVENT().MFA_SMS.success);
            else Analytics.record(ANALYTICS_EVENT().MFA_OFF.success);
            updateCurrentAuthUserWithoutCache(dispatch);
          })
          .catch(e => {
            console.log(e);
            Analytics.record(ANALYTICS_EVENT(e.message).MFA_SMS.error);

            const message =
              e.message === "User does not have a phone_number set to turn on SMS MFA."
                ? "Please fill-in and verify your Phone Number to turn SMS MFA on."
                : e.message;

            // dispatch({ type: SETUP_MFA_SMS_ERROR, payload: message });
            dispatch({
              type: PUSH_NOTIFICATION,
              payload: { message: message, type: "error" }
            });
          });
      }
    } else {
      Auth.setupTOTP(user)
        .then(code => {
          // console.log("from profileAcreenActions Auth.setupTOTP : ", code);
          dispatch({ type: SETUP_TOTP, payload: code });
          updateCurrentAuthUserWithoutCache(dispatch);
          // ...
        })
        .catch(e => {
          // dispatch({ type: SETUP_MFA_ERROR, payload: e.message });
          dispatch({
            type: PUSH_NOTIFICATION,
            payload: { message: e.message, type: "error" }
          });
        });
    }
  };
};

export const enterVerificationMFACode = input => {
  return function(dispatch) {
    console.log("from profileScreenActions toggle_value: ", input);

    dispatch({ type: ENTER_VERIFICATION_MFA_CODE, payload: input });
  };
};

export const verifyTotpToken = (user, challengeAnswer) => {
  return function(dispatch) {
    console.log("from profileScreenActions toggle_value: ", challengeAnswer);

    Auth.verifyTotpToken(user, challengeAnswer)
      .then(() => {
        // don't forget to set TOTP as the preferred MFA method
        Auth.setPreferredMFA(user, "TOTP");
        Analytics.record(ANALYTICS_EVENT().MFA_TOTP.success);
        // console.log("from verifyTotpToken: challenge verified and setPreferedMFA set to TOPT");
        dispatch({ type: SETUP_MFA_INFO });
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: { message: "Successfully set TOTP for your MFA.", type: "success" }
        });
        // ...
      })
      .catch(e => {
        // Token is not verified
        console.log("from profileScreenActions error: ", e);
        Analytics.record(ANALYTICS_EVENT(e.message).MFA_TOTP.error);
        // dispatch({ type: SETUP_MFA_ERROR, payload: e.message });
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: { message: e.message, type: "error" }
        });
      });
  };
};

export const updateUserAttr = (user, attributes, phoneChanged) => {
  return async function(dispatch) {
    let image = await generateUserPicture(null, attributes.given_name + " " + attributes.family_name);
    attributes.picture = image;

    Auth.updateUserAttributes(user, attributes)
      .then(data => {
        if (data === "SUCCESS") {
          updateCurrentAuthUserWithoutCache(dispatch);
          if (phoneChanged) {
            setTimeout(() => {
              dispatch(resendSMSVerificationCode());
            }, 1000);
          }
          dispatch({
            type: PUSH_NOTIFICATION,
            payload: { message: "Successfully updated user attributes.", type: "success" }
          });
        } else {
          dispatch({
            type: PUSH_NOTIFICATION,
            payload: { message: data.message, type: "error" }
          });
        }

        // ...
      })
      .catch(e => {
        // dispatch({ type: UPDATE_USER_ATTR_ERROR, payload: e.message });
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: { message: e.message, type: "error" }
        });
      });
  };
};

export const resendSMSVerificationCode = () => {
  return function(dispatch) {
    // console.log("from profileScreenActions toggle_value: ");

    Auth.verifyCurrentUserAttribute("phone_number")
      .then(() => {
        console.log("a verification code is sent");
        // dispatch({
        //   type: RESEND_SUBMIT_SMS_VERIFICATION_CODE,
        //   payload: { message: "Verification code is sent to your mobile.", type: "info" }
        // });
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: { message: "Verification code is sent to your mobile.", type: "success" }
        });
      })
      .catch(e => {
        console.log("ERRRRRRROR");
        // dispatch({
        //   type: RESEND_SUBMIT_SMS_VERIFICATION_CODE,
        //   payload: { message: e.message, type: "error" }
        // });
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: { message: e.message, type: "error" }
        });
      });
  };
};

export const submitSMSVerificationCode = code => {
  return function(dispatch) {
    // console.log("from profileScreenActions toggle_value: ", attributes);

    Auth.verifyCurrentUserAttributeSubmit("phone_number", code)
      .then(() => {
        // console.log("phone_number verified");
        updateCurrentAuthUserWithoutCache(dispatch);
        // dispatch({
        //   type: RESEND_SUBMIT_SMS_VERIFICATION_CODE,
        //   payload: { message: "Phone number successfully verified.", type: "info" }
        // });
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: { message: "Phone number successfully verified.", type: "success" }
        });
      })
      .catch(e => {
        // dispatch({ type: RESEND_SUBMIT_SMS_VERIFICATION_CODE, payload: { message: e.message, type: "error" } });
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: { message: e.message, type: "error" }
        });
      });
  };
};

const updateCurrentAuthUserWithoutCache = dispatch => {
  Auth.currentAuthenticatedUser({ bypassCache: true }).then(currentAuthUser => {
    // console.log("Updated currentAuthenticatedUser(): ", currentAuthUser);
    dispatch({ type: AUTH_USER, payload: currentAuthUser });
  });
};

export const fetchMyContacts = (fromValue, limitValue) => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "ListUsers2",
      PaginationFrom: fromValue,
      PaginationLimit: limitValue,
      ...API_REQUEST_FIXED_PARAMS
    }
  };

  const res = {};
  try {
    const response = await API.post(config.AWS_API_NAME, "users/new", data);

    res["code"] = response.code;

    if (response.code == 200) {
      res["data"] = response;
    }
  } catch (err) {
    res["code"] = 500;
    res["data"] = [];
  }

  dispatch({
    type: FETCH_MY_CONTACTS,
    payload: res
  });
};

export const inviteUser = props => async (dispatch, getState) => {
  const state = getState();

  const customTenant = props.existingUser.attributes["custom:tenant"];

  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "InviteUser",
      FormParams:
        "email=" +
        encodeURIComponent(props.invitedUser.email) +
        "&tenant=" +
        encodeURIComponent(customTenant) +
        "&userType=" +
        encodeURIComponent(props.invitedUser.userType),
      ...API_REQUEST_FIXED_PARAMS
    }
  };

  const response = await API.post(config.AWS_API_NAME, "users/new", data);

  dispatch({
    type: PUSH_NOTIFICATION,
    payload: { message: response.message, type: response.status }
  });

  dispatch(fetchMyContacts());
};

export const reinviteUser = userEmail => async (dispatch, getState) => {
  const action = {
    type: REINVITE_USER,
    payload: { status: 500 }
  };

  const state = getState();

  try {
    const requestData = {
      body: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        ApiCall: "ReinviteUser",
        UserEmail: userEmail,
        ...API_REQUEST_FIXED_PARAMS
      }
    };
    const response = await API.post(config.AWS_API_NAME, "users/new", requestData);
    action.payload.status = response.code;
  } catch (err) {}

  dispatch(action);
};

export const changeUserRole = (userEmail, newRole) => async (dispatch, getState) => {
  const action = {
    type: CHANGE_USER_ROLE,
    payload: { status: 500 }
  };

  const state = getState();

  try {
    const requestData = {
      body: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        ApiCall: "ChangeUserRole",
        Username: userEmail,
        NewRole: newRole,
        ...API_REQUEST_FIXED_PARAMS
      }
    };
    const response = await API.post(config.AWS_API_NAME, "users/new", requestData);
    action.payload.status = response.code;
  } catch (err) {}

  dispatch(action);
};
